import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { TrackModalService } from '@core/services/track-open-modals.service';
import { BehaviorSubject } from 'rxjs';

@Directive()
@Injectable()
export class ConfirmModalService {
  private modal: any;

  @Output() btnEvent = new EventEmitter<any>();
  private orderCommingSoon = new BehaviorSubject<string>(' ');
  ordCommingSoon = this.orderCommingSoon.asObservable();

  constructor(
    private trackModalService: TrackModalService
  ) {
  }

  // this is called by the confirm-modal.component at the start of the application loading once
  public setModal(component: any) {
    this.modal = component;
  }

  public setHeader(header: string) {
    this.modal.setHeader(header);
  }

  public setSubHeader(header: string) {
    this.modal.setSubHeader(header);
  }

  public setMessage(message: string) {
    this.modal.setMessage(message);
  }

  public setBtn1Text(text: string) {
    this.modal.setBtn1Text(text);
  }

  public setBtn2Text(text: string) {
    this.modal.setBtn2Text(text);
  }

  public setCancelText(text: string) {
    this.modal.setCancelText(text);
  }

  public showModal(hidePrevious: boolean = true) {
    this.modal.showPreset(hidePrevious);
    this.trackModalService.setConfirmOpen(true);
  }

  private timeout(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  public async show(
    header: string = '',
    subHeader: string = '',
    message: string = '',
    btn1Text: string = '',
    btn2Text: string = '',
    cancelText: string = '',
    hidePrevious: boolean = true,
    btn1Emit: string = 'btn1',
    btn2Emit: string = 'btn2',
    cancelEmit: string = 'close',
  ) {
    if (this.trackModalService.getModalOpen()) {
      this.hideModal();
      await this.timeout(3000);
    }
    this.modal.show(
      header,
      subHeader,
      message,
      btn1Text,
      btn2Text,
      cancelText,
      hidePrevious,
      btn1Emit,
      btn2Emit,
      cancelEmit,
    );
    document.body.classList.add('modal-open');
    this.trackModalService.setConfirmOpen(true);
  }

  public hideModal() {
    this.modal.hide();
    if (!this.trackModalService.getModalOpen()) {
      document.body.classList.remove('modal-open');
    }
    this.trackModalService.setConfirmOpen(false);
  }

 public findOrderCommingSoon(orderdt: string) {
    this.orderCommingSoon.next(orderdt);
  }

  onBtnEvent(data: any) {
    this.btnEvent.emit(data);
  }
}
